<script lang="ts">
    import {UrlStateManagerService} from 'shared/state-manager';
    import {getInjector} from 'src/core';
    import {SearchType} from 'shared/constants';
    import type {SearchParams, StaticSearchParams} from 'src/typings';
    import KpSearchContext from '../kp-search-context/KpSearchContext.svelte';
    import KpFullPageSearch from './KpFullPageSearch.svelte';
    import KpCatalogSearch from './KpCatalogSearch.svelte';

    export let staticParams: Partial<StaticSearchParams>;

    const urlStateManagerService = getInjector().getByClass(UrlStateManagerService<SearchParams>);

    $: urlParams$ = urlStateManagerService.getState$();
</script>

<KpSearchContext {staticParams} let:searchManager>
    {#if $urlParams$?.type === SearchType.TYPE_CATALOG}
        <KpCatalogSearch {searchManager}/>
    {:else }
        <KpFullPageSearch {searchManager}/>
    {/if}
</KpSearchContext>